import React from 'react';

import Avatar from '@material-ui/core/Avatar';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

import indigo from '@material-ui/core/colors/indigo';

const styles = theme => ({
  root: {

  },
  avatar: {
    margin: 10,
    color: '#fff',
    backgroundColor: indigo[100],
  },
  horizontalContent: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'no-wrap',
    justifyContent: 'space-evenly',
    alignItems: 'center',
  },
  verticalContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    paddingTop: theme.spacing.unit*2,
    paddingBottom: theme.spacing.unit*2,
  },
  verticalValue: {
    color: indigo[300],
  },
  horizontalValue: {
    color: '#fff',
  },
});

const Metric = ({ classes, type, label, value, size }) => {
  return(
    <div>
      {type === "horizontal" &&
        <div className={classes.horizontalContent}>
          <Typography>
            {label}
          </Typography>
          <Avatar className={classes.avatar}>
            <Typography variant="headline" className={classes.horizontalValue}>
              {value}
            </Typography>
          </Avatar>
        </div>
      }
      {type === "vertical" &&
        <div className={classes.verticalContent}>
          <Typography
            variant="headline"
            className={classes.verticalValue}>
            {value}
          </Typography>
          <Typography>
            {label}
          </Typography>
        </div>
      }
    </div>
  );
};

export default withStyles(styles)(Metric);



// WEBPACK FOOTER //
// ./src/components/Info/Metric.jsx